'use client';

import { usePathname } from 'next/navigation';

import { useCurrentExperiment } from '@/lib/experimentation';
import { track } from '@/lib/tracker';

type UseTrackPricingCardClickOptions = {
  trackEventName: string;
  trackId: string | undefined;
  trackExtra?: Record<string, unknown>;
};

export function useTrackPricingCardClick({
  trackEventName,
  trackId,
  trackExtra,
}: UseTrackPricingCardClickOptions) {
  const pathname = usePathname();
  const experiment = useCurrentExperiment();

  return (extra?: Record<string, unknown>) => {
    try {
      track(trackEventName, {
        id: trackId,
        pathname,
        is_in_experiment_page: !!experiment,
        ...(experiment && {
          exp_experiment_id: experiment.flagId,
          variant_id: experiment.variant,
        }),
        ...trackExtra,
        ...extra,
      });
    } catch {}
  };
}
